/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Final_Cta_SecondaryInputs */

const en_dr_final_cta_secondary = /** @type {(inputs: Dr_Final_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk to us`)
};

const id_dr_final_cta_secondary = /** @type {(inputs: Dr_Final_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami`)
};

/**
* | output |
* | --- |
* | "Talk to us" |
*
* @param {Dr_Final_Cta_SecondaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_final_cta_secondary = /** @type {((inputs?: Dr_Final_Cta_SecondaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Final_Cta_SecondaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_final_cta_secondary(inputs)
	return en_dr_final_cta_secondary(inputs)
});